import { __rest, __assign } from 'tslib';
import React from 'react';
import { OptionDesktop } from './desktop/Component.js';
import { OptionMobile } from './mobile/Component.js';
import '../checkmark/Component.js';
import 'classnames';
import '../../../../badge/esm';
import '../../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import '@alfalab/icons-glyph/CheckmarkMIcon';
import './Component.js';
import '../../consts.js';
import '../checkmark-mobile/Component.js';

var OptionResponsive = function (_a) {
    var mobile = _a.mobile, props = __rest(_a, ["mobile"]);
    return mobile ? React.createElement(OptionMobile, __assign({}, props)) : React.createElement(OptionDesktop, __assign({}, props));
};

export { OptionResponsive };
